import { render } from "./FilterComponentControls.vue?vue&type=template&id=7cd3571f"
import script from "./FilterComponentControls.vue?vue&type=script&lang=js"
export * from "./FilterComponentControls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__